import {
  useQuery, UseQueryResult,
} from '@tanstack/react-query';
import { getVehiclesReport } from '../../services/Reports';

function useGetVehiclesReport(fleetId: string, query: string): UseQueryResult<any> {
  return useQuery(
    ['report-vehicles', fleetId, query],
    async (): Promise<any> => getVehiclesReport(fleetId, query),
    {
      retry: 1,
      retryDelay: 3000,
      keepPreviousData: false,
      refetchInterval: false,
    },
  );
}

export default useGetVehiclesReport;
